import * as React from 'react';
import classNames from 'classnames';

import styles from './Backdrop.module.css';
import { PropsWithChildren } from 'react';

export const Backdrop = ({
  onClick,
  isLeaving,
  className,
  children,
}: PropsWithChildren<{
  onClick?: () => void;
  isLeaving?: boolean;
  className?: string;
}>) => {
  return (
    <div
      onClick={onClick}
      className={classNames(styles.backdrop, className, {
        [styles.backdropLeaving]: isLeaving,
      })}
    >
      {children}
    </div>
  );
};
